import IMG from "../../constants/image";
import ImageBasic from "../Common/Image/ImageBasic";

const FormSuccess = () => {
    return (
        <div className='flex animate-fadeIn flex-col justify-center items-center text-black space-y-3 text-sm'>
            <ImageBasic className='w-[7rem]' src={IMG.icon.iconSuccess}/>
            <div>Cập nhật địa chỉ thành công</div>
        </div>
    )
}
export default FormSuccess